module.exports = __webpack_public_path__ + "static/media/photo13.d7b9f1eb.png";